var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c(_setup.Header),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm"},[_c('router-view')],1)]),_c(_setup.Footer)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }